export const tokens = {
  card: {
    md: {
      value: "0px 2px 5px 0px rgba(0, 0, 0, 0.1)",
    },
  },
};
